<template>
  <div class="blue-background">
    <the-header></the-header>
    <vs-row>
      <vs-col :lg="3" :sm="12"><side-bar></side-bar></vs-col>
      <vs-col
        :lg="9"
        :sm="12"
        style="position: relative; display: block"
        class="mml-1 mb-8"
      >
        <router-view></router-view
      ></vs-col>
    </vs-row>
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import SideBar from "@/components/SideBar.vue";

export default {
  components: {
    TheHeader,
    SideBar,
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
}

body {
  margin: 0;
}

.container {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  max-width: 40rem;
  margin: 3rem auto;
  padding: 1rem;
  border-radius: 12px;
}

.route-enter,
.route-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.route-enter-active,
.route-leave-active {
  transition: all 0.3s ease;
}

.route-enter-to,
.route-leave {
  opacity: 1;
  transform: translateY(0);
}
</style>
